

Greenmile.DataImport = Greenmile.DataImport || {};

Greenmile.DataImport.MappingScreenCsv = (function () {

    function MappingScreenCsv(preview) {

        this.className ='MappingScreenCsv';
        this.table = null;
        this.type = 'CSV';
        this.title = 'Greenmile.DataImport.CSVMappingScreen.title';

        Greenmile.DataImport.MappingScreen.apply(this, arguments);

        this.validate = function() {
            Greenmile.DataImport.Utils.clearErrorMessage();

            var result = { errorMessages: [] },
                values = this.getValue(),
                status = true;

            if ( !values.name ) {
                result.errorMessages.push(
                    Monet.Form.Messages.mountErrorMessageObject('Greenmile.DataImport.layoutNameIsMandatory'))
                status =  false;
            }

            var columnsWithoutPath = [];
            for ( var i = 0, length=values.columns.length; i < length; i++ ) {
                var column = values.columns[i];
                if ( !column.fieldPath && (!column.fileColumnNum || !column.defaultValue) ) {
                    result.errorMessages.push(
                      Monet.Form.Messages.mountErrorMessageObject('Greenmile.DataImport.pathNotFound', column.fileColumnName)
                    );
                    columnsWithoutPath.push(column);
                    status =  false;
                }

                if ( column.fieldPath && column.fileColumnNum && column.defaultValue ) {

                    result.errorMessages.push(
                        Monet.Form.Messages.mountErrorMessageObject('Greenmile.DataImport.selectColumnNumOrDefault', column.fileColumnName)
                    );
                    columnsWithoutPath.push(column);
                    status =  false;
                }

                delete column.type;
            }

            result.value = values;
            result.invalidColumns = columnsWithoutPath;
            result.status = status;

            return result;

        }.bind(this);

        this.getCsvColumnsValue = function() {
            var lines = this.table.table.childNodes;
            var columns = [];

            for (var i = 1; i< lines.length; i++) {
                var line = lines[i],
                    csvFieldPath = line.querySelector('.csv').getAttribute('path'),
                    columnNum = line.querySelector('.csv').getAttribute('fileColumnNum') || undefined,
                    objToReturn = this.table.getFixedValuesByLine(line);

                if ( csvFieldPath ) {
                    objToReturn.fileColumnName = csvFieldPath;
                    objToReturn.fileColumnNum = parseInt(columnNum);
                }

                columns.push(objToReturn);
            }

            return columns;

        }.bind(this);

        this.getValue = function() {
            var name = this.layoutName.getValue(),
                data = App.Forms.DataImport.CSVConfigurations.getValue();

            data.name = name;
            data.fileType = this.type;
            data.rootEntity = App.Forms.DataImport.EntityList.getSelected();

            data.configuration = this.advancedConfigs.getValue();
            data.columns = this.getCsvColumnsValue();
            if (this.value && this.value.id) {
                data.id = this.value.id;
            }

            return data;
        };

        this.setLinesValue = function() {
            var lines = this.table.childNodes,
                columns = this.layout.columns,
                columnsObj = {},
                model = null,
                line = null,
                i = 0,
                removedColumns;

            for(var key in columns) {
                var column = columns[key];
                columnsObj[column.fieldPath] = column;
            }

            var setLine = function(model, line) {
                model.path = model.fieldPath;
                model.label = this.gmFieldList[model.fieldPath].label;
                model.type = this.gmFieldList[model.fieldPath].type;
                this.setFixedColumnsValue(line, model);
                this.selectGMFieldValue(model, line.querySelector('.gm  span.value'));

            }.bind(this);


            for ( i = 1; i< lines.length; i++) {
                line = lines[i];
                var csvFieldPath = line.querySelector('.csv').getAttribute('path'),
                    gmFieldPath = line.querySelector('.gm').getAttribute('path');

                model = columnsObj[gmFieldPath];
                this.setFixedColumnsValue(line, model);
                columnsObj[model.fieldPath].matched = model.fileColumnName === csvFieldPath;
            }

            removedColumns =  columns.filter(function(i) {
                return ( !i.defaultValue && !i.matched ? i : null);
            });

            for(i = 0; i < removedColumns.length; i++) {
                model = removedColumns[i];
                model.value = '';
                line = this.addNewLine(model, preview, null);
                setLine(model, line);
                line.className += ' removed-field';
                line.removeAttribute('path');
                line.removeAttribute('fileColumnNum');
                line.querySelector('.csv').removeAttribute('path');
                line.querySelector('.csv').removeAttribute('fileColumnNum');
                line.querySelector('.csv .preview').innerHTML = Monet.I18n.getResourcesByKey('Greenmile.DataImport.fieldMappedButNotFoundOnFile');
            }
        };
    }

    return MappingScreenCsv;
}());